export type CurrentStep = number;

export type WantNextStep = boolean;

export interface WizardStoreState {
  currentStep: CurrentStep;
  wantNextStep: WantNextStep;
  updateFormState: boolean;
  fwNavDisabled: boolean;
  lastStep: number;
  isPageLoading: boolean;
  globalError: boolean;
  isScrollToErrorElement: boolean;
}

export const initWizardStoreState: WizardStoreState = {
  currentStep: 1,
  wantNextStep: false,
  updateFormState: false,
  fwNavDisabled: false,
  lastStep: 1,
  isPageLoading: false,
  globalError: false,
  isScrollToErrorElement: false,
};
